module.exports = __webpack_public_path__ + "static/closed-orders-388ff9d39eadf410f4d4eb68645e74fc.gif";